const AUTOSTART_TV_PREFIX = '@AUTOSTART_TV';

export const SET_AUTOSTART_TV = `${AUTOSTART_TV_PREFIX}/SET_AUTOSTART_TV`;
